/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as Material from "@mui/material";
import * as Icons from "@mui/icons-material";
import { Grid, TextField, Box, MenuItem, Button, FormControlLabel, Checkbox, IconButton, DialogActions, DialogContent, Dialog, DialogTitle } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { closelightbox } from '../../util/Functions';
import { Close } from "@mui/icons-material";

const Validate = (props) => {
  const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(true);
  const [reason, setReason] = useState("");
  const [files, setFiles] = useState([]);
  const [names, setNames] = useState([]);
  const [comment, setComment] = useState("");
  const [multipleComment, setMultipleComment] = useState([]);
  const [pep, setPep] = useState("");
  const [pepError, setPepError] = useState(false);
  const [listReason, setListReason] = useState([]);
  const [title, setTitle] = useState("");
  const [field, setField] = useState({});
  const [textField, setTextField] = useState("");
  const [checkField, setCheckField] = useState([]);
  const [checkIndex, setCheckIndex] = useState(null);
  const listClevelReason = [
    {key: "Pep + alto riesgo"},
    {key: "Cliente alto riesgo"},
    {key: "PEP"},
    {key: "No Pep + No Cliente alto riesgo"},
    {key: "No PEP"},
    {key: "No Cliente alto riesgo"},
    {key: "Abuso de la plataforma"},
  ]

  useEffect(() => {
    init();
  }, [props.contentModal]);

  const init = async () => {
    if (props.contentModal) {
      if (props.contentModal.content) {
        if (props.contentModal.content.catalogs) {
          setListReason(
            JSON.parse(JSON.stringify(props.contentModal.content.catalogs))
          );
        }
        if (props.contentModal.content.flag) {
          let type = props.contentModal.content.flag;
          if (type === "validated") {
            setTitle("Validar Identificación");
          }
          if (type === "invalidated") {
            setTitle("Solicitar Documentos");
          }
          if (type === "rejected") {
            setTitle("Rechazar Identificación");
          }
          if (type === "waiting_for_auth") {
            setTitle("Asignar Cliente");
          }
          if (type === "validated" && hasAction("clevelRisk")) {
            setTitle("Aprobar Cliente de Alto Riesgo");
          }
          if (type === "rejected" && hasAction("clevelRisk")) {
            setTitle("Rechazar Cliente de Alto Riesgo");
          }
        }
      }
    }
    setPep(props.pep)
  };

  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

  const send = async () => {
    props.changeLoader(true);
    setZPos(-1)

    let r = "";
    if (field?.hasOwnProperty("type")) {
      if (field["type"] == "text" || field["type"] == "select") {
        r = `${reason}: ${textField}`;
      }
      if (field["type"] == "checkbox") {
        let checks = [];
        for (let i = 0; i < checkField.length; i++) {
          if (checkField[i]["checked"]) {
            checks.push(checkField[i]["value"]);
          }
        }
        r = `${reason}: ${checks.join(", ")}`;
      }
    }
    if(pep === "undefined"){
      setPepError(true)
    } else {
      setPepError(false)
    }
    await props.updateStatus(props.contentModal.content.flag, r ? r : reason, files, comment, pep);
 
    const lightbox = document.getElementsByClassName('lightbox');
    lightbox.length > 0 && setZPos(45);
  };

  const onSelectReason = (e) => {
    let openField = false;
    let tF = "";
    let fi = {};
    let checks = [];
    for (let i = 0; i < listReason.length; i++) {
      if (listReason[i]["key"] == e.target.value) {
				if(listReason[i].hasOwnProperty("comment")){
					setComment(listReason[i]["comment"])
				} else {
					setComment("")
				}
        if (listReason[i]["openfield"]) {
          openField = true;
          tF = "";
          fi = listReason[i]["field"];
          if (listReason[i]["field"]["type"] == "checkbox") {
            checks = listReason[i]["field"]["values"];
          }
        } else {
          setField([]);
        }
      }
    }
    
    setCheckField(JSON.parse(JSON.stringify(checks)));
    setField(JSON.parse(JSON.stringify(fi)));
    validateButton(e.target.value, openField, tF);
    setReason(e.target.value);
    setTextField(tF);
    setMultipleComment([]);
  };

  const onFileLoad = async (e, file) => {
    let img = e.target.files[0];
    let reader = new FileReader();
    if (img) {
      reader.readAsDataURL(img);
      reader.onload = await ((binding) => {
        return async () => {
          let f = files;
          let n = names;
          if (f.length < 4) {
            let base64 = reader.result.toString();
            let fileName = img.name;
            f.push(base64);
            n.push(fileName);
            setFiles(JSON.parse(JSON.stringify(f)));
            setNames(JSON.parse(JSON.stringify(n)));
          }
        };
      })(this);
    }
  };

  const addImage = () => {
    document.getElementById("file").click();
  };
  const keyPush = (e) => {
    console.log(e.target.value);
  };

  const eliminar = (index) => {
    let f = files;
    let n = names;
    let newFiles = [];
    let newNames = [];
    for (let i = 0; i < f.length; i++) {
      if (i != index) {
        newFiles.push(f[i]);
        newNames.push(n[i]);
      }
    }
    setFiles(JSON.parse(JSON.stringify(newFiles)));
    setNames(JSON.parse(JSON.stringify(newNames)));
  };

  const changeComment = (e) => {
    if(e.target.value){
      setDisabled(false);
    }
    setComment(e.target.value);
  };

  const changeMultipleComment = (e) => {
    const value = e.target.value;
    setMultipleComment(value);
    typeof value === "string" ? setComment(value) : setComment(value.join(", "));
  };

  const changePep = (e) => {
    setPep(e.target.value);
  };

  const validateButton = (reason, openFile, values) => {
    if (reason) {
      if (!openFile) {
        setDisabled(false);
      } else {
        if (!values) {
          setDisabled(true);
        } else {
          setDisabled(false);
        }
      }
    } else {
      setDisabled(true);
    }
  };

  const changeFieldText = (e) => {
    setTextField(e.target.value);
    validateButton(reason, true, e.target.value);
  };

  const validateCheck = (list) => {
    let count = 0;
    for (let i = 0; i < list.length; i++) {
      if (list[i]["checked"]) {
        count++;
      }
    }

    if (count) {
      setDisabled(false);
    } else {
      setCheckIndex(null);
      setDisabled(true);
    }
  };

  const changeCheckbox = (index, e) => {
    let checks = checkField;
    for (let i = 0; i < checks.length; i++) {
      if (i == index) {
        e.target.checked && setCheckIndex(i);
        checks[i]["checked"] = e.target.checked;
      }
    }
    setComment("");
    setMultipleComment([]);
    validateCheck(checks);
    setCheckField(JSON.parse(JSON.stringify(checks)));
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          {title}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent sx={{paddingBottom: "0px" }}>
          <Grid container spacing={2} style={{marginTop: "1%"}} >			
            <Grid item xs={12}>
              <TextField
                value={reason} onChange={onSelectReason.bind(this)}	label={props.contentModal.content.flag != "waiting_for_auth" ? "Motivo" : "Agente"} select	size="small" fullWidth  >
                <MenuItem value="" disabled>{props.contentModal.content.flag != "waiting_for_auth" ? "Selecione un motivo" : "Seleccione un agente"}</MenuItem>
                { !hasAction("clevelRisk") && listReason?.map((item, index) => (
                  <MenuItem key={index} value={props.contentModal.content.flag != "waiting_for_auth" ? item.key : item.uuid}>{item.key}</MenuItem>
                ))}
                { hasAction("clevelRisk") && listClevelReason?.map((item, index) => (
                  <MenuItem key={index} value={item.key}>{item.key}</MenuItem>
                ))}
              </TextField>
            </Grid>

            {field?.hasOwnProperty("type") && field["type"] == "text" && (
              <Grid item xs={12}>
                <TextField
                  value={textField} multiline minRows={1} maxRows={2} onChange={changeFieldText.bind(this)} label={field["label"]} size="small" fullWidth />
              </Grid>
            )}

            {field?.hasOwnProperty("type") && field["type"] == "select" && (
              <Grid item xs={12}>
                <TextField
                  value={comment || ""} label={field["label"]} select multiline minRows={1} maxRows={2} onChange={changeComment.bind(this)} size="small" fullWidth >
                  <MenuItem value="" disabled>{field["label"]}</MenuItem>
                  {field["values"]?.map((item, index) => {
                    return <MenuItem key={index} value={item}>{item}</MenuItem>
                })}
                </TextField>
              </Grid>
            )}

            {field?.hasOwnProperty("type") && field["type"] == "checkbox" &&
              <Grid container spacing={2} sx={{ margin: "12px", marginLeft: "0" }} >
                {checkField.map((item, index) => {
                  return (
                    <Grid item xs={6} style={{paddingTop: "0"}}  key={`check-${index}`}>
                      <FormControlLabel control={<Checkbox checked={item["checked"]} 	onChange={changeCheckbox.bind(this, index)}/>} label={item["label"]} />
                    </Grid>
                  )
                })}
              </Grid>
            }
            {field?.hasOwnProperty("type") && field["type"] == "checkbox" && checkIndex !== null && checkField[checkIndex]?.hasOwnProperty("select") && (
              <Grid item xs={12}>
                <TextField 
                  SelectProps={{multiple: checkField[checkIndex]['multiple'] ? true : false, value: multipleComment, onChange: changeMultipleComment.bind(this)}}
                  value={comment || ""} label={checkField[checkIndex]["select"]["label"]} select multiline minRows={1} maxRows={2} onChange={changeComment.bind(this)} size="small" fullWidth >
                  <MenuItem value={""} disabled>Seleccione...</MenuItem>
                  {checkField[checkIndex]["select"]["values"]?.map((item, index) => {
                    return <MenuItem key={index} value={item}>{item}</MenuItem>
                })}
                </TextField>
              </Grid>
            )}

            {props.contentModal.content.flag != "waiting_for_auth" && !field?.hasOwnProperty("type") && (
              <Grid item xs={12}>
                <TextField
                  value={comment || ""} multiline minRows={1} maxRows={2} onChange={changeComment.bind(this)} label="Comentarios" size="small" fullWidth />
              </Grid>
            )}
            {props.contentModal.content.flag != "waiting_for_auth" && (field?.hasOwnProperty("type") && field["type"] !== "select") && (checkIndex == null || !checkField[checkIndex]?.hasOwnProperty("select")) && (
              <Grid item xs={12}>
                <TextField
                  value={comment || ""} multiline minRows={1} maxRows={2} onChange={changeComment.bind(this)} label="Comentarios" size="small" fullWidth />
              </Grid>
            )}

            {(props.contentModal.content.flag === "validated" || props.contentModal.content.flag === "rejected") && (
              <Grid item xs={6}>
                <TextField
                  value={pep} onChange={changePep.bind(this)} label="PEP" size="small" select  error={pepError} helperText={pepError ? "Dato obligatorio" : ''} fullWidth >
                    <MenuItem value={"true"}>{"Si"}</MenuItem>
                    <MenuItem value={"false"}>{"No"}</MenuItem>
                </TextField>
              </Grid>
            )}

            {props.contentModal.content.flag != "waiting_for_auth" && (
              <Grid item xs={12}>
                <TextField
                  id="file" type="file" onChange={onFileLoad.bind(this)} size="small" fullWidth style={{ display: "none" }}/>
              </Grid>
            )}

            {files.length > 0 && names.length > 0 && 
              names.map((item, index) => {
                return (
                  <Grid key={index} container spacing={2} sx={{marginLeft: "0", marginBottom: "11px" }} >							
                    <Grid item xs={6}>
                      <TextField value={item} onKeyDown={keyPush.bind(this)} 
                      label={`Evidencia ${index + 1}`} key={`file-${index}`} disabled size="small" fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                      <Box style={{textAlign: "end"}}>
                        <Button id="buttonDelete" variant="outlined" onClick={eliminar.bind(this, index)} >Eliminar</Button>
                      </Box>
                    </Grid>
                  </Grid>	
                );
              })}					

            {props.contentModal.content.flag != "waiting_for_auth" && (
              <Grid item xs={12}>
                <Material.IconButton onClick={addImage.bind(this)}	disabled={names.length == 4 && files.length == 4 ? true : false}>
                  <Icons.AttachFile />
                </Material.IconButton>
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Guardar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default Validate;
